import { LocalStorage, MemoryStorage, SessionStorage } from "../storage";
export function getStorageMechanism() {
    const SDKStorageMechanisms = ['sessionStorage', 'memoryStorage'];
    const avaliablityOfStorageMechanisms = new Map();
    SDKStorageMechanisms.forEach((data) => {
        avaliablityOfStorageMechanisms.set(data, checkForStorageAvailabilty(data));
    });
    const result = Array.from(avaliablityOfStorageMechanisms.entries()).filter((data) => {
        if (data[1]) {
            return data[0];
        }
    }).map((sm) => sm[0]);
    return resolveStorageMechanism(result[0]);
}
function checkForStorageAvailabilty(type) {
    switch (type) {
        case 'localStorage':
            let testKey = '__checkFor__localStorage';
            try {
                localStorage.setItem(testKey, testKey);
                localStorage.removeItem(testKey);
                return true;
            }
            catch (e) {
                return false;
            }
        case 'sessionStorage':
            const dummyKey = '__checkFor__sessionStorage';
            try {
                sessionStorage.setItem(dummyKey, dummyKey);
                sessionStorage.removeItem(dummyKey);
                return true;
            }
            catch (e) {
                return false;
            }
        default: return true;
    }
}
function resolveStorageMechanism(type) {
    if (type === 'sessionStorage') {
        return new SessionStorage();
    }
    else if (type === 'localStorage') {
        return new LocalStorage();
    }
    else {
        return new MemoryStorage({});
    }
}
//# sourceMappingURL=index.js.map